import { Directive } from '@angular/core';
import { CdkMenuItem } from '@angular/cdk/menu';
import { SharedMenuItemDirective } from '@seech/shared-ng';

@Directive({
  selector: '[sch-menu-item]',
  standalone: true,
  providers: [
    {
      provide: CdkMenuItem,
      useExisting: MenuItemDirective,
    },
  ],
})
export class MenuItemDirective extends SharedMenuItemDirective {
}
